<button (click)="onClickClose()" class="delete"></button>
<div [innerHTML]="this.message"></div>
